<template>
    <div class="awards" :style="{'background': '#F8F8F8'}" v-if="data && data.title">
        <div class="awards-header">
            <h2 class="after-center">{{ data.title }}</h2>
        </div>
        <p :style="{'textAlign': 'center'}" v-if="data.description">{{ data.description }}</p>
        <div class="row awards-swiper-container swiper-container wide-slider" v-if="data.award">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(award, i) in data.award" :key="i">
                    <a class="box">
                        <div class="text">
                            <img class="image" v-if="award.image.url" :src="award.image.url" alt />
                            <div class="name" v-html="award.title"></div>
                            <div class="desc" v-if="award.description">
                                <p v-html="award.description"></p>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <div class="awards-swiper-prev wide-slider-prev"></div>
            <div class="awards-swiper-next wide-slider-next"></div>
        </div>
    </div>
</template>

<script>
// this is slider for Contac -> specific location
export default {
    props: ["data"],
    name: "awards-slider-contact-location",
    mounted: function() {
        var awardsSwiper = new Swiper(".awards-swiper-container", {
            loop: true,
            slidesPerView: "auto",
            centeredSlides: true,
            initialSlide: 1,
            nextButton: ".awards-swiper-next",
            prevButton: ".awards-swiper-prev",
            speed: 500
        });
    }
};
</script>


// WEBPACK FOOTER //
// AwardsSliderContactLocation.vue?d2c0ca6a